module.exports = __webpack_public_path__ + "img/Small-2-Bevel-Attachment-16.fd2fb8de.png";